module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hidden_Heritage2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-5"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Take the staff, and you and your brother Aaron gather the assembly together. Speak to that rock before their eyes and it will pour out its water. You will bring water out of the rock for the community so they and their livestock can drink.")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-6"
  }, [_vm._v("—Numbers 20:8 (NIV)")]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-7"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9f2cdcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hidden_Heritage-5.vue
// module id = 75
// module chunks = 0